export default "__VITE_ASSET__bvzuwNKj__"